module.exports = __webpack_public_path__ + "static/media/Ternana.b540f542.png";